import {Trans} from 'react-i18next'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import makeStyles from '@material-ui/core/styles/makeStyles'
import messages from '../../../assets/messages'
import {config} from '../../../config'

const useStyles = makeStyles((theme) => ({
  label: {
    fontSize: '0.875rem',
    lineHeight: 1.4,
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
  root: {
    // The label wraps on mobile; top-align the box with the first line.
    alignItems: 'flex-start',
  },
  checkbox: {
    paddingTop: 0,
  },
}))

/**
 * The factorised-account Terms & Conditions document. A dedicated link is optional
 * per white-label, so fall back to the general legal documents page rather than
 * rendering a dead link.
 */
export const getTauroTermsUrl = (): string =>
  config.weblinks?.tauroFactorisationTerms || config.weblinks?.legalDocuments || ''

type TauroTermsCheckboxProps = {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  id?: string
}

/**
 * Mandatory Terms & Conditions acceptance for opening a Tauro 10x factorised
 * account (PT-5492). The caller owns the state and keeps its submit button
 * disabled until `checked` is true, mirroring PammTermsCheckbox.
 */
export const TauroTermsCheckbox = ({
  checked,
  onChange,
  disabled = false,
  id = 'tauroTermsCheckbox',
}: TauroTermsCheckboxProps) => {
  const classes = useStyles()

  return (
    <FormControlLabel
      classes={{label: classes.label, root: classes.root}}
      control={
        <Checkbox
          checked={checked}
          className={classes.checkbox}
          color="primary"
          disabled={disabled}
          id={id}
          inputProps={{'aria-label': 'tauroTermsCheckbox'} as never}
          onChange={(e) => onChange(e.target.checked)}
        />
      }
      label={
        <Trans
          {...messages.tauroTermsCheckbox}
          components={[
            <a
              className={classes.link}
              href={getTauroTermsUrl()}
              rel="noreferrer noopener"
              target="_blank"
            >
              terms
            </a>,
          ]}
        />
      }
    />
  )
}
